<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title" v-html="$t('message.title_bell_edit_display', { name: bellInfo.name })"></div>
                <hr class="dialog-hr" />
                <div class="dialog-body">
                    <el-form label-width="200px" class="dialog-form-item">
                        <!-- 表示言語 -->
                        <el-form-item prop="languageCodes" ref="languageCodes">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_bell_edit_label5'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                            </div>
                            <el-select id="languageCodes" v-model="inputForm.languageCodes.value"
                                :placeholder="$t('message.place_holder_select_item')" multiple
                                style="width: 100%;" clearable
                                @clear="clearLanguageCodeHandler"
                                @change="changeLanguageCodeHandler()">
                                <el-option v-for="language in languageList" :key="language.value"
                                    :label="languageDescription(language)" :value="language.languageCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!--- ページ設定 --->
                        <div style="margin-bottom: 20px;">
                            <el-button type="primary" size="small" @click="addPage()">
                                <span v-t="'message.item_bell_edit_btn1'"></span>
                            </el-button>
                        </div>
                        <el-tabs v-model="currentTabName" type="card" @tab-remove="removeTab">
                            <el-tab-pane v-for="(tab, tabIndex) in pageTabs" :key="tab.name" :label="tab.title"
                                :name="tab.name" :closable="0 < tabIndex && tabIndex < lastIndex">
                                <div class="page">
                                    <el-form v-for="(pageItem, pageIndex) in tab.pageItems" :inline="true"
                                        :model="pageItem">
                                        <template v-if="tabIndex === lastIndex">
                                            <!-- last messages -->
                                            <el-form-item style="width: 18%;">
                                                <el-select v-model="pageItem.lang"
                                                    :placeholder="$t('message.item_bell_edit_placeholder1')" disabled
                                                    style="font-size:12px">
                                                    <el-option style="font-size:12px" v-for="language in languageList"
                                                        :key="language.value" :label="languageDescription(language)"
                                                        :value="language.languageCode">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-input type="textarea" style="width: 500px;"
                                                    :autosize="{ minRows: 5, maxRows: 5 }" v-model="pageItem.title"
                                                    :placeholder="$t('message.item_bell_edit_placeholder4')"
                                                    :maxlength="isFullWidthLanguage(pageItem.lang) ? MAX_MESSAGE_LENGTH : MAX_MESSAGE_LENGTH2"
                                                    show-word-limit>
                                                </el-input>
                                            </el-form-item>
                                        </template>
                                        <template v-else>
                                            <!-- pages -->
                                            <el-form-item style="width: 18%;">
                                                <el-select v-model="pageItem.lang"
                                                    :placeholder="$t('message.item_bell_edit_placeholder1')" disabled
                                                    style="font-size:12px">
                                                    <el-option style="font-size:12px" v-for="language in languageList"
                                                        :key="language.value" :label="languageDescription(language)"
                                                        :value="language.languageCode">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-input type="textarea" style="width: 340px;"
                                                    :autosize="{ minRows: 3, maxRows: 3 }" v-model="pageItem.title"
                                                    :placeholder="$t('message.item_bell_edit_placeholder2')"
                                                    :maxlength="isFullWidthLanguage(pageItem.lang) ? MAX_TITLE_LENGTH : MAX_TITLE_LENGTH2"
                                                    show-word-limit>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item
                                                v-for="(selection, selectionIndex) in pageItem.selections">
                                                <el-input type="textarea" style="width: 340px;"
                                                    :autosize="{ minRows: 3, maxRows: 3 }" v-model="pageItem.selections[selectionIndex]"
                                                    :placeholder="$t('message.item_bell_edit_placeholder3')"
                                                    :maxlength="isFullWidthLanguage(pageItem.lang) ? MAX_SELECTION_LENGTH : MAX_SELECTION_LENGTH2"
                                                    show-word-limit>
                                                </el-input>
                                            </el-form-item>
                                        </template>
                                    </el-form>
                                </div>
                                <template v-if="tabIndex !== lastIndex">
                                    <el-button type="primary" @click="addSelection(tabIndex)">
                                        <span v-t="'message.item_bell_edit_btn2'"></span>
                                    </el-button>
                                    <el-button @click="deleteSelection(tabIndex)">
                                        <span v-t="'message.item_bell_edit_btn3'"></span>
                                    </el-button>
                                </template>
                            </el-tab-pane>
                        </el-tabs>
                    </el-form>
                </div>
                <hr class="dialog-hr" />
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')"
                        v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="disableButton" @click="saveChange()"
                        v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import constants from "./constants";
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';

export default {

    props: {
        bellInfo: Object,
        appData: Object,
    },

    data() {
        return {
            DEFAULT_LANGUAGE_CODE: null,
            DEFAULT_SECONDARY_LANGUAGE_CODE: null,
            FULL_WIDTH_LANGUAGES: ["ja-JP", "zh-CN", "zh-TW", "ko-KR"],

            MAX_TITLE_LENGTH: constants.BELL_MAX_TITLE_LENGTH,
            MAX_SELECTION_LENGTH: constants.BELL_MAX_SELECTION_LENGTH,
            MAX_MESSAGE_LENGTH: constants.BELL_MAX_MESSAGE_LENGTH,
            MAX_TITLE_LENGTH2: constants.BELL_MAX_TITLE_LENGTH2,
            MAX_SELECTION_LENGTH2: constants.BELL_MAX_SELECTION_LENGTH2,
            MAX_MESSAGE_LENGTH2: constants.BELL_MAX_MESSAGE_LENGTH2,

            // Fields
            inputForm: {
                languageCodes: {
                    validationRule: "requireArray",
                    valid: true, // set DEFAULT_LANGUAGE_CODE when add(new).
                    value: [],
                    isComposing: false,
                }
            },

            pageTabs: [], // checking when pushed save button only.
            // controllers
            languageList: [],
            oldLanguageCodes: [],
            disableButton: false,
            currentTabName: 1,
            tabNameCounterForPage: 0,
        };
    },

    computed: {
        existsSettings() {
            return this.bellInfo != null
                && this.bellInfo.settings != null
                && this.bellInfo.settings.context
                && Object.keys(this.bellInfo.settings.context).length !== 0;
        },
        lastIndex() {
            return this.pageTabs.length - 1;
        },
    },

    created() {
        this.DEFAULT_LANGUAGE_CODE = this.$i18n.locale === 'ja' ? 'ja-JP' : 'en-US';
        this.DEFAULT_SECONDARY_LANGUAGE_CODE = this.$i18n.locale === 'ja' ? 'en-US' : 'ja-JP';
        this.languageList = commonUtil.getLanguageIndexList();
        this.initTabs();
        this.setButtonStatus();
    },

    methods: {
        isFullWidthLanguage(lang) {
            return this.FULL_WIDTH_LANGUAGES.includes(lang);
        },
        languageDescription(language) {
            if (this.$i18n.locale === 'ja') {
                return language.description;
            } else {
                return language.description_en
            }
        },
        saveChange() {
            // input check
            this.inputCheckAll();
            if (!this.isCheckAllOk()) return;

            let payload = {
                id: this.bellInfo.id,
                settings: {
                    context: this.createContext(),
                },
            };

            this.$emit("update", payload);
        },
        createContext() {
            // init context
            const context = {}
            this.pageTabs[0].pageItems.forEach(({ lang }) => {
                context[lang] = []
            })
            // Push page
            this.pageTabs.forEach(({ pageItems }) => {
                pageItems.forEach(({ lang, title, selections }) => {
                    context[lang].push({ title, selections })
                });
            });
            return context
        },
        // Component-related
        initTabs() {
            this.pageTabs = [];
            if (!this.existsSettings) {
                // Add
                this.inputForm.languageCodes.value = [this.DEFAULT_LANGUAGE_CODE, this.DEFAULT_SECONDARY_LANGUAGE_CODE]
                this.oldLanguageCodes = [this.DEFAULT_LANGUAGE_CODE, this.DEFAULT_SECONDARY_LANGUAGE_CODE]
                // Adding from the last
                this.addPage(true);
                this.addPage();
            } else {
                // Edit
                this.setEditData();
            }
        },
        addPage(isLastMessage = false) {
            // limit = page(2) + lastmesage(1) = 3
            if (this.pageTabs.length === constants.BELL_MAX_PAGE_SIZE + 1) {
                commonUtil.notifyMessageWithDuration(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_bell_max_page_size").replace("{limit}", constants.BELL_MAX_PAGE_SIZE), 3000);
                return;
            }
            if (isLastMessage) {
                // init page of last
                this.pageTabs.push({
                    title: "Last Msg",
                    name: "last",
                    pageItems: [
                        {
                            lang: this.DEFAULT_LANGUAGE_CODE,
                            title: "",
                            selections: null, // not use
                        },
                        // Set secondary language to imply to the user that bell is multilingual.
                        {
                            lang: this.DEFAULT_SECONDARY_LANGUAGE_CODE,
                            title: "",
                            selections: null, // not use
                        }
                    ],
                    selectionNum: -1 // not use
                });
            } else {
                const newTabName = ++this.tabNameCounterForPage;
                // init page
                const selectionNum = 1;
                const pageItems = this.inputForm.languageCodes.value.map(languageCode => {
                    return {
                        lang: languageCode,
                        title: "",
                        selections: Array(selectionNum).fill(""),
                    }
                })
                // Add before the last
                this.pageTabs.splice(-1, 0, {
                    title: `Page-${this.pageTabs.length}`,
                    name: newTabName,
                    pageItems: pageItems,
                    selectionNum: selectionNum,
                });
                this.currentTabName = newTabName;
            }
        },
        setEditData() {
            let settings = this.bellInfo.settings;

            this.inputForm.languageCodes.value = Object.keys(settings.context)
            this.inputForm.languageCodes.valid = true;
            this.oldLanguageCodes = Array.from(this.inputForm.languageCodes.value);

            let languageCount = 0
            for (const [languageCode, pages] of Object.entries(settings.context)) {
                languageCount++
                pages.forEach((page, idx) => {
                    const pageItem = {
                        lang: languageCode,
                        title: page.title,
                        selections: page.selections ? page.selections : null
                    }
                    if (languageCount === 1) {
                        // Create Tab and Set items when first
                        const lastIdx = pages.length - 1;
                        let tab
                        if (lastIdx === idx) {
                            tab = {
                                title: "Last Msg",
                                name: "last",
                                pageItems: [pageItem],
                                selectionNum: -1
                            }
                        } else {
                            const newTabName = idx + 1
                            this.tabNameCounterForPage = newTabName
                            tab = {
                                title: `Page-${newTabName}`,
                                name: newTabName,
                                pageItems: [pageItem],
                                selectionNum: page.selections.length
                            }
                        }
                        this.pageTabs.push(tab)
                    } else {
                        // Set items
                        const pageItem = {
                            lang: languageCode,
                            title: page.title,
                            selections: page.selections ? page.selections : null
                        }
                        this.pageTabs[idx].pageItems.push(pageItem)
                    }
                })
            }
        },
        isCheckAllOk() {
            return commonValidate.checkFormValidation(this.inputForm) && this.pageSettingCheck();
        },
        pageSettingCheck() {
            for (const tab of this.pageTabs) {
                for (const { title, selections } of tab.pageItems) {
                    if (title.length === 0) {
                        return false;
                    }
                    if (selections !== null) {
                        for (const selection of selections) {
                            if (selection.length === 0) {
                                return false;
                            }
                        }
                    }
                }
            }
            return true;
        },
        setButtonStatus() {
            this.disableButton = !commonValidate.checkFormValidation(this.inputForm);
        },
        clearLanguageCodeHandler() {
            this.clearAllLanguageCodes();
            this.oldLanguageCodes = Array.from(this.inputForm.languageCodes.value);
            this.inputCheck('languageCodes');
        },
        changeLanguageCodeHandler() {
            // create command
            let operation
            let longArray
            let shortArray
            if (this.inputForm.languageCodes.value.length < this.oldLanguageCodes.length) {
                operation = "del"
                longArray = this.oldLanguageCodes
                shortArray = this.inputForm.languageCodes.value
            } else {
                operation = "add"
                longArray = this.inputForm.languageCodes.value
                shortArray = this.oldLanguageCodes
            }
            const targetLanguageCode = longArray.filter(item => shortArray.indexOf(item) === -1)[0];

            // operate tabs
            switch (operation) {
                case "add":
                    this.addLanguageCode(targetLanguageCode)
                    break;
                case "del":
                    this.deleteLanguageCode(targetLanguageCode)
                    break
                default:
                    console.error(`Unimplemented operation. operation=${operation}`)
                    break;
            }
            this.oldLanguageCodes = Array.from(this.inputForm.languageCodes.value);
            this.inputCheck('languageCodes');
        },
        addLanguageCode(targetLanguageCode) {
            const lastIdx = this.pageTabs.length - 1;
            this.pageTabs.forEach(({ selectionNum, pageItems }, idx) => {
                if (idx === lastIdx) {
                    pageItems.push({
                        lang: targetLanguageCode,
                        title: "",
                        selections: null
                    });
                } else {
                    pageItems.push({
                        lang: targetLanguageCode,
                        title: "",
                        selections: Array(selectionNum).fill(""),
                    });
                }
            })
        },
        clearAllLanguageCodes() {
            this.pageTabs.forEach(pageTab => {
                pageTab.pageItems = [];
            })
        },
        deleteLanguageCode(targetLanguageCode) {
            this.pageTabs.forEach(pageTab => {
                pageTab.pageItems = pageTab.pageItems.filter(({ lang }) => lang !== targetLanguageCode)
            })
        },
        addSelection(tabIndex) {
            if (this.pageTabs[tabIndex].selectionNum === constants.BELL_MAX_SELECTION_SIZE) {
                commonUtil.notifyMessageWithDuration(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_bell_max_selection_size").replace("{limit}", constants.BELL_MAX_SELECTION_SIZE), 3000);
                return;
            }
            this.pageTabs[tabIndex].selectionNum++
            this.pageTabs[tabIndex].pageItems.forEach(item => item.selections.push(""))
        },
        deleteSelection(tabIndex) {
            if (this.pageTabs[tabIndex].selectionNum == 1) {
                commonUtil.notifyMessageWithDuration(this, "Warning", commonUtil.getMessageText(this.$i18n, "item_bell_edit_warn1"), 3000);
                return
            }
            this.pageTabs[tabIndex].selectionNum--
            this.pageTabs[tabIndex].pageItems.forEach(item => item.selections.pop())
        },
        removeTab(targetName) {
            const tabs = this.pageTabs;
            let activeName = this.currentTabName;
            if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.name === targetName) {
                        const nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            activeName = nextTab.name;
                        }
                    }
                });
            }
            this.currentTabName = activeName;
            this.pageTabs = tabs.filter(tab => tab.name !== targetName);
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            const validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                this.inputForm[eventTargetId].valid = true;
                this.$refs[eventTargetId].clearValidate();
            } else {
                this.inputForm[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        inputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
            if (!this.pageSettingCheck()) {
                commonUtil.notifyMessageWithDuration(this, "Error", commonUtil.getMessageText(this.$i18n, "item_bell_edit_page_setting_error"), 3000);
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
    }
};
</script>

<style scoped>
.page {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 10px;
    overflow-x: scroll;
    white-space: nowrap;
}
.dialog-body {
    max-height: calc(80vh - 170px);
    padding: 20px 30px;
    font-size: 14px;
    overflow: auto;
}
</style>
